import { NgModule } from '@angular/core';

import { LecturesModule } from '../lectures/lectures.module';
import { SharedModule } from '../shared/shared.module';

import { CourseAddButtonComponent } from './course-add-button/course-add-button.component';
import { CourseBillingButtonComponent } from './course-billing-button/course-billing-button.component';
import { CourseDetailNavDirective } from './course-detail/course-detail-nav.directive';
import { CourseDetailComponent } from './course-detail/course-detail.component';
import { CourseEditButtonComponent } from './course-edit-button/course-edit-button.component';
import { CourseEnrollButtonComponent } from './course-enroll-button/course-enroll-button.component';
import { CourseEnrollmentStatusComponent } from './course-enrollment-status/course-enrollment-status.component';
import { CourseListComponent } from './course-list/course-list.component';
import { CourseMemberItemComponent } from './course-member-item/course-member-item.component';
import { CourseMemberListComponent } from './course-member-list/course-member-list.component';
import { CourseMembersButtonComponent } from './course-members-button/course-members-button.component';
import { CourseSyllabusButtonComponent } from './course-syllabus-button/course-syllabus-button.component';
import { CourseComponent } from './course/course.component';
import { CoursesRoutingModule } from './courses-routing.module';
import { CoursesComponent } from './courses/courses.component';
import { CourseCommentService } from './shared/course-comment.service';
import { CourseLectureService } from './shared/course-lecture.service';
import { CourseResolver } from './shared/course-resolver.service';
import { CourseUserService } from './shared/course-user.service';
import { CourseService } from './shared/course.service';
import { CourseGroupMailButtonComponent } from './course-group-mail-button/course-group-mail-button.component';
import { UiModule } from "../ui/ui.module";
import { SyllabusesModule } from "../syllabuses/syllabuses.module";

@NgModule({
  imports: [
    SharedModule,
    CoursesRoutingModule,
    SyllabusesModule,
    LecturesModule,
    UiModule
  ],
  declarations: [
    CoursesComponent,
    CourseComponent,
    CourseListComponent,
    CourseDetailComponent,
    CourseDetailNavDirective,
    CourseAddButtonComponent,
    CourseBillingButtonComponent,
    CourseEditButtonComponent,
    CourseEnrollButtonComponent,
    CourseEnrollmentStatusComponent,
    CourseMemberListComponent,
    CourseMemberItemComponent,
    CourseMembersButtonComponent,
    CourseSyllabusButtonComponent,
    CourseGroupMailButtonComponent
  ],
  exports: [
    CourseComponent
  ],
  providers: [
    CourseService,
    CourseResolver,
    CourseLectureService,
    CourseUserService,
    CourseCommentService
  ]
})
export class CoursesModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/courses.module.ts